import React, { useCallback } from 'react';

export const useKeyDownCatcher = <E>() => {
    return useCallback((event: React.KeyboardEvent<E>) => {
        event.preventDefault();
        event.stopPropagation();
    }, []);
};
